var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrinning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grinning_Face_With_Sweat",
    "data-name": "Grinning Face With Sweat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,512c-68.28,0-132.5-24.9-180.828-70.109C26.7,396.543,0,336.208,0,272S26.7,147.457,75.172,102.109C123.5,56.9,187.72,32,256,32s132.5,24.9,180.828,70.109C485.3,147.457,512,207.792,512,272s-26.7,124.543-75.172,169.891C388.5,487.1,324.28,512,256,512Z",
    style: {
      fill: "#ffcc80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.828,102.109q-7.974-7.46-16.52-14.16A226.918,226.918,0,0,1,432,160c0,64.208-26.7,124.543-75.172,169.891C308.5,375.1,244.28,400,176,400c-60.77,0-118.312-19.737-164.308-55.949,12.209,36.542,33.737,70.015,63.48,97.84C123.5,487.1,187.72,512,256,512s132.5-24.9,180.828-70.109C485.3,396.543,512,336.208,512,272S485.3,147.457,436.828,102.109Z",
    style: {
      fill: "#ffb74d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,464c-79.4,0-144-64.6-144-144v-8a24.028,24.028,0,0,1,24-24H376a24.028,24.028,0,0,1,24,24v8C400,399.4,335.4,464,256,464Z",
    style: {
      fill: "#e27484"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,272a8,8,0,0,1-8-8,24,24,0,0,0-48,0,8,8,0,0,1-16,0,40,40,0,0,1,80,0A8,8,0,0,1,192,272Z",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,272a8,8,0,0,1-8-8,24,24,0,0,0-48,0,8,8,0,0,1-16,0,40,40,0,0,1,80,0A8,8,0,0,1,384,272Z",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,192a72.081,72.081,0,0,1-72-72c0-16.364,11.27-40.391,33.5-71.414,16.065-22.423,31.871-40.17,32.536-40.915L440,.991l5.967,6.68c.665.745,16.47,18.492,32.536,40.915C500.73,79.609,512,103.636,512,120A72.081,72.081,0,0,1,440,192Z",
    style: {
      fill: "#2196f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.4,74.375a108.008,108.008,0,0,1-106.19,96.61A71.963,71.963,0,0,0,512,120C512,108.5,506.427,93.211,495.4,74.375Z",
    style: {
      fill: "#1e88e5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 72,
    r: 16,
    style: {
      fill: "#90caf9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 120,
    r: 24,
    style: {
      fill: "#90caf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.845,425.259a216.285,216.285,0,0,1,242-115.931A24.033,24.033,0,0,0,376,288H136a24.028,24.028,0,0,0-24,24v8A143.623,143.623,0,0,0,157.845,425.259Z",
    style: {
      fill: "#d8667c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 280,
    r: 24,
    style: {
      fill: "#ffe4c0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 280,
    r: 24,
    style: {
      fill: "#ffe4c0"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrinning);
export default __webpack_public_path__ + "static/media/grinning.95c91877e3b48d903177148ca4566a34.svg";
export { ForwardRef as ReactComponent };